import { Pipe } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

// tslint:disable-next-line: use-pipe-transform-interface
@Pipe({ name: 'imagePipe' })
export class ImagePipe {
  constructor(private sanitizer: DomSanitizer) { }

  transform(html: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(html);
  }
}
